import { Button } from '@mui/material'
import { styled } from '@mui/material/styles'
import React, { type PropsWithChildren } from 'react'

const StyledButton = styled(Button)({
  background: 'rgba(255, 255, 255, 0.25) !important',
  boxShadow: '0 4px 8px 0 rgba(31, 38, 135, 0.17)',
  backdropFilter: 'blur(4px)',
  borderRadius: '10px',
  border: '1px solid rgba(255, 255, 255, 0.18)',
  padding: 0
})

interface GlassBoxProps extends PropsWithChildren {
  onClick?: () => void
  className?: string
}

export default function GlassButton ({ children, onClick, className = '' }: GlassBoxProps) {
  return <StyledButton onClick={onClick} className={className}>
    {children}
  </StyledButton>
}
